import React from "react";
import { Button, Stack } from "@mui/joy";
import DefaultPage from "pages/container/DefaultPage";
import distancingLogo from "static/image/common/distancing_logo.png";
import CustomTypography from "../../common/CustomTypography";
import CustomTypographyHighlight from "../../common/CustomTypographyHighlight";
import { theme } from "../../../styles/theme";
import { useRecoilValue } from "recoil";
import { userSimpleAtom } from "../../../recoil/userSimpleAtom";
import { isDev } from "../../../config";
import useAutoLoginPromotion from "../../../hooks/useAutoLoginPromotion";
import { buildResumeInstallDeepLink } from "data/deepLinkData";

// 제휴 로그인 이후 결과 화면.
// - 적용 대상(구독/결제 이력 전무) → 기존 install OneLink 로 앱 딥링킹
// - 비대상 → "처음 시작하는 분에게만 적용" 안내 후 앱에서 계속
export default function ReferralResult() {
  useAutoLoginPromotion();
  const user = useRecoilValue(userSimpleAtom);

  const eligible = !!user?.isAffiliateEligible;
  const isDiscountReferral = user?.referralCodeType === "discount";

  const openApp = () =>
    window.open(
      buildResumeInstallDeepLink(isDev, user?.authenticateType),
      "_blank"
    );

  return (
    <DefaultPage
      backgroundColor={theme.vars.palette.Background.Level3}
      content={
        <Stack alignItems="center" spacing={5}>
          <Stack spacing={4} alignItems={"center"} sx={{ width: "100%" }}>
            <img
              src={distancingLogo}
              alt="distancing logo"
              style={{ width: "138px", height: "auto" }}
            />
            {eligible ? (
              <Stack
                spacing={"12px"}
                alignItems="center"
                sx={{ width: "100%" }}
              >
                <CustomTypography
                  variant={"H2"}
                  sx={{
                    textAlign: "center",
                    color: theme.vars.palette.Content.Strong,
                    fontWeight: 700,
                    whiteSpace: "pre-wrap",
                  }}
                >
                  {"구독자 전용 우대 혜택이\n적용되었습니다"}
                </CustomTypography>
                <CustomTypographyHighlight
                  variant={"Subtitle"}
                  highlightedText={
                    isDiscountReferral ? "담당 인원이 제한" : "1일"
                  }
                  highlightVariant={"Subtitle"}
                  highlightSx={{
                    color: theme.vars.palette.Content.Highlight,
                    fontWeight: 700,
                  }}
                  sx={{
                    textAlign: "center",
                    color: theme.vars.palette.Content.Medium,
                    fontWeight: 500,
                  }}
                >
                  {isDiscountReferral
                    ? "코치별 담당 인원이 제한되어 있어,\n조기 마감될 수 있습니다.\n앱에서 프로그램을 계속해주세요."
                    : "우대 혜택은 1일 동안 유지됩니다.\n앱에서 프로그램을 계속해주세요."}
                </CustomTypographyHighlight>
              </Stack>
            ) : (
              <CustomTypography
                variant={"Subtitle"}
                sx={{
                  textAlign: "center",
                  color: theme.vars.palette.Content.Strong,
                  fontWeight: 500,
                  whiteSpace: "pre-wrap",
                }}
              >
                {
                  "구독자 전용 우대 혜택은 프로그램을\n처음 시작하시는 분들에게만 적용됩니다.\n앱에서 프로그램을 계속해주세요."
                }
              </CustomTypography>
            )}
          </Stack>
          <Stack spacing={1.5} alignItems={"center"} sx={{ width: "100%" }}>
            <Button
              onClick={openApp}
              variant={"Solid"}
              color={"primary"}
              size={"lg"}
              sx={{
                width: "100%",
                maxWidth: "345px",
                height: "54px",
                fontWeight: 700,
                borderRadius: "12px",
                fontSize: "16px",
              }}
            >
              {"앱 실행하기"}
            </Button>
          </Stack>
        </Stack>
      }
    />
  );
}
